import { Link, Outlet } from 'react-router-dom'

export default function RootLayout() {
  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-3 focus:bg-[var(--color-text)] focus:text-white focus:rounded-lg focus:font-bold"
      >
        Zum Hauptinhalt springen
      </a>
      <main id="main-content" className="min-h-svh flex flex-col">
        <Outlet />
      </main>
      <footer className="px-6 py-3 flex flex-wrap justify-center items-center gap-x-2 text-[13px] text-[var(--color-text-secondary)]">
        <Link to="/impressum" className="inline-flex items-center min-h-[44px] px-2 underline-offset-2 hover:underline">
          Impressum
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/datenschutz" className="inline-flex items-center min-h-[44px] px-2 underline-offset-2 hover:underline">
          Datenschutz
        </Link>
      </footer>
    </>
  )
}
